// extracted by mini-css-extract-plugin
export default {"form":"SignIn_form__buMOc","input":"SignIn_input__c5J6u","container":"SignIn_container__ohDgQ","submit":"SignIn_submit__0uFbc","link":"SignIn_link__XsWkA"};